import React from 'react'
import { MdRefresh } from 'react-icons/md'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type ClearControlProps = {
  onClick: () => void
}

const ClearControl = ({ onClick }: ClearControlProps) => {
  return (
    <div className={cn('control', 'clear')} data-graph-type="control" title="Clear">
      <a className={cn('icon')} onClick={onClick}>
        <MdRefresh aria-hidden />
        <span className="sr-only">Clear</span>
      </a>
    </div>
  )
}

export default ClearControl
